module.exports = __webpack_public_path__ + "img/Gplay.d97ab263.png";